<template>
  <el-dialog custom-class="mini-dialog" title="修改运费" :visible.sync="dialogFormVisible" center :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="运费" :label-width="formLabelWidth" prop="expressfee">
            <el-input-number v-model="form.expressfee" :controls="false" style="width: 100px"  :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    name: "UpdateExpressFee",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        form: {  //表单数据
          expressfee: ''
        },

        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          expressfee: [
            {required: true, message: '请输入运费', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(expressfee) {
        this.initForm();
        this.form.expressfee=Math.abs(expressfee)
        this.dialogFormVisible = true;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.dialogFormVisible = false;
            this.$emit('afterUpdateExpressFee',-Math.abs(this.form.expressfee));
          }
        });
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
    },
    components: {
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/UpdateExpressFee.vue